$(document).on('turbolinks:load', () => {
  $('.sign-in input').on('input', clearSignInFormAfterEntry)
  $('.sign-up input').on('input', clearSignUpFormAfterEntry)
})

function clearSignInFormAfterEntry() {
  $('#new_user input').removeClass('invalid-input')
  $('#new_user small').remove()
}

function clearSignUpFormAfterEntry() {
  const input = $(this)
  const elementId = input.attr('id')
  input.removeClass('invalid-input')
  $(`.${elementId}-error`).remove()
}
